// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/uicustomization/uicustomization.proto (package aurora.core.apiengine.uicustomizationv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { UIConfigVisibility } from "../../../../consts/uiconfigconsts_pb";
import { file_consts_uiconfigconsts } from "../../../../consts/uiconfigconsts_pb";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/uicustomization/uicustomization.proto.
 */
export const file_modules_apiengine_services_uicustomization_uicustomization: GenFile = /*@__PURE__*/
  fileDesc("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", [file_consts_uiconfigconsts, file_google_protobuf_struct]);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.CreateConfigRequest
 */
export type CreateConfigRequest = Message<"aurora.core.apiengine.uicustomizationv1.CreateConfigRequest"> & {
  /**
   * Configurations are grouped by a name, typically the name of the page like `orderbook`, `open_positions`, ...
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * By the default a config is private to the user but the user may decide to
   * share (readonly/readwrite) with colleagues
   *
   * @generated from field: aurora.core.consts.uiconfig.UIConfigVisibility visibility = 2;
   */
  visibility: UIConfigVisibility;

  /**
   * Actual config struct as json blob
   *
   * @generated from field: google.protobuf.Struct config = 3;
   */
  config?: JsonObject;

  /**
   * Display order of the config, the user can drag configs around to reorder them
   *
   * @generated from field: int32 position = 4;
   */
  position: number;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.CreateConfigRequest.
 * Use `create(CreateConfigRequestSchema)` to create a new message.
 */
export const CreateConfigRequestSchema: GenMessage<CreateConfigRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 0);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.CreateConfigResponse
 */
export type CreateConfigResponse = Message<"aurora.core.apiengine.uicustomizationv1.CreateConfigResponse"> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.CreateConfigResponse.
 * Use `create(CreateConfigResponseSchema)` to create a new message.
 */
export const CreateConfigResponseSchema: GenMessage<CreateConfigResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 1);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.ModifyConfigRequest
 */
export type ModifyConfigRequest = Message<"aurora.core.apiengine.uicustomizationv1.ModifyConfigRequest"> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string;

  /**
   * By the default a config is private to the user but the user may decide to
   * share (readonly/readwrite) with colleagues
   *
   * @generated from field: aurora.core.consts.uiconfig.UIConfigVisibility visibility = 2;
   */
  visibility: UIConfigVisibility;

  /**
   * Actual config struct as json blob
   *
   * @generated from field: google.protobuf.Struct config = 3;
   */
  config?: JsonObject;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.ModifyConfigRequest.
 * Use `create(ModifyConfigRequestSchema)` to create a new message.
 */
export const ModifyConfigRequestSchema: GenMessage<ModifyConfigRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 2);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.ModifyConfigResponse
 */
export type ModifyConfigResponse = Message<"aurora.core.apiengine.uicustomizationv1.ModifyConfigResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.ModifyConfigResponse.
 * Use `create(ModifyConfigResponseSchema)` to create a new message.
 */
export const ModifyConfigResponseSchema: GenMessage<ModifyConfigResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 3);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.DeleteConfigRequest
 */
export type DeleteConfigRequest = Message<"aurora.core.apiengine.uicustomizationv1.DeleteConfigRequest"> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.DeleteConfigRequest.
 * Use `create(DeleteConfigRequestSchema)` to create a new message.
 */
export const DeleteConfigRequestSchema: GenMessage<DeleteConfigRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 4);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.DeleteConfigResponse
 */
export type DeleteConfigResponse = Message<"aurora.core.apiengine.uicustomizationv1.DeleteConfigResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.DeleteConfigResponse.
 * Use `create(DeleteConfigResponseSchema)` to create a new message.
 */
export const DeleteConfigResponseSchema: GenMessage<DeleteConfigResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 5);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.MoveConfigRequest
 */
export type MoveConfigRequest = Message<"aurora.core.apiengine.uicustomizationv1.MoveConfigRequest"> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string;

  /**
   * @generated from field: int32 new_position = 2;
   */
  newPosition: number;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.MoveConfigRequest.
 * Use `create(MoveConfigRequestSchema)` to create a new message.
 */
export const MoveConfigRequestSchema: GenMessage<MoveConfigRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 6);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.MoveConfigResponse
 */
export type MoveConfigResponse = Message<"aurora.core.apiengine.uicustomizationv1.MoveConfigResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.MoveConfigResponse.
 * Use `create(MoveConfigResponseSchema)` to create a new message.
 */
export const MoveConfigResponseSchema: GenMessage<MoveConfigResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 7);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.GetConfigsByNameRequest
 */
export type GetConfigsByNameRequest = Message<"aurora.core.apiengine.uicustomizationv1.GetConfigsByNameRequest"> & {
  /**
   * Configurations are grouped by a name, typically the name of the page like `orderbook`, `open_positions`, ...
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.GetConfigsByNameRequest.
 * Use `create(GetConfigsByNameRequestSchema)` to create a new message.
 */
export const GetConfigsByNameRequestSchema: GenMessage<GetConfigsByNameRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 8);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.GetConfigsByNameResponse
 */
export type GetConfigsByNameResponse = Message<"aurora.core.apiengine.uicustomizationv1.GetConfigsByNameResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.uicustomizationv1.UIConfig configs = 1;
   */
  configs: UIConfig[];
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.GetConfigsByNameResponse.
 * Use `create(GetConfigsByNameResponseSchema)` to create a new message.
 */
export const GetConfigsByNameResponseSchema: GenMessage<GetConfigsByNameResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 9);

/**
 * @generated from message aurora.core.apiengine.uicustomizationv1.UIConfig
 */
export type UIConfig = Message<"aurora.core.apiengine.uicustomizationv1.UIConfig"> & {
  /**
   * Config identifier
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Configurations are grouped by a name, typically the name of the page like `orderbook`, `open_positions`, ...
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * By the default a config is private to the user but the user may decide to
   * share (readonly/readwrite) with colleagues
   *
   * @generated from field: aurora.core.consts.uiconfig.UIConfigVisibility visibility = 3;
   */
  visibility: UIConfigVisibility;

  /**
   * Actual config struct as json blob
   *
   * @generated from field: google.protobuf.Struct config = 4;
   */
  config?: JsonObject;

  /**
   * Display order of the config, the user can drag configs around to reorder them
   *
   * @generated from field: int32 position = 5;
   */
  position: number;

  /**
   * The user can be the owner of the configuration but the configuration can also be shared by a colleague
   *
   * @generated from field: bool is_owner = 6;
   */
  isOwner: boolean;
};

/**
 * Describes the message aurora.core.apiengine.uicustomizationv1.UIConfig.
 * Use `create(UIConfigSchema)` to create a new message.
 */
export const UIConfigSchema: GenMessage<UIConfig> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_uicustomization_uicustomization, 10);

/**
 * Methods to create and modify UI configs
 *
 * @generated from service aurora.core.apiengine.uicustomizationv1.UICustomizationService
 */
export const UICustomizationService: GenService<{
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.uicustomizationv1.UICustomizationService.CreateConfig
   */
  createConfig: {
    methodKind: "unary";
    input: typeof CreateConfigRequestSchema;
    output: typeof CreateConfigResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.uicustomizationv1.UICustomizationService.ModifyConfig
   */
  modifyConfig: {
    methodKind: "unary";
    input: typeof ModifyConfigRequestSchema;
    output: typeof ModifyConfigResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.uicustomizationv1.UICustomizationService.DeleteConfig
   */
  deleteConfig: {
    methodKind: "unary";
    input: typeof DeleteConfigRequestSchema;
    output: typeof DeleteConfigResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.uicustomizationv1.UICustomizationService.MoveConfig
   */
  moveConfig: {
    methodKind: "unary";
    input: typeof MoveConfigRequestSchema;
    output: typeof MoveConfigResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.uicustomizationv1.UICustomizationService.GetConfigsByName
   */
  getConfigsByName: {
    methodKind: "unary";
    input: typeof GetConfigsByNameRequestSchema;
    output: typeof GetConfigsByNameResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_uicustomization_uicustomization, 0);

